
export enum PageStatus {
    None = 'None',
    Found = 'Found',
    Loading = 'Loading',
    NotFound = 'NotFound',
    Error = 'Error'
}

type NoPageSate = {
    readonly status: PageStatus.None
}

type FoundPageState = {
    readonly status: PageStatus.Found
    readonly name: string,
    readonly routeData: {[key: string]: string|undefined}
}

type LoadingPageState = {
    readonly status: PageStatus.Loading
    readonly name: string,
    readonly routeData: {[key: string]: string|undefined}
}

type NotFoundPageState = {
    readonly status: PageStatus.NotFound
}

type ErrorPageState = {
    readonly status: PageStatus.Error
    readonly name?: string,
    readonly routeData?: {[key: string]: string|undefined}
}

export type PageState =
    NoPageSate
    | FoundPageState
    | LoadingPageState
    | NotFoundPageState
    | ErrorPageState;